// How a job's status is named and coloured wherever it is shown: the live panel on the map pages
// and the jobs list on the home page. DaisyUI classes are written out in full so the scanner
// generates them.

export interface JobStatusBadge {
  text: string;
  /** A DaisyUI badge colour class. */
  className: string;
}

const capitalise = (s: string): string => (s ? s.charAt(0).toUpperCase() + s.slice(1) : s);

export function jobStatusBadge(status: string | null | undefined): JobStatusBadge {
  switch (status) {
    case 'queued':
      return { text: 'Queued', className: 'badge-info' };
    case 'processing':
    case 'running':
      return { text: 'Processing', className: 'badge-warning' };
    case 'completed':
      return { text: 'Completed', className: 'badge-success' };
    case 'failed':
      return { text: 'Failed', className: 'badge-error' };
    default:
      return { text: capitalise(status ?? '') || 'Unknown', className: 'badge-ghost' };
  }
}
